import { render, staticRenderFns } from "./BioDialog.vue?vue&type=template&id=296d466c&scoped=true"
import script from "./BioDialog.vue?vue&type=script&lang=js"
export * from "./BioDialog.vue?vue&type=script&lang=js"
import style0 from "./BioDialog.vue?vue&type=style&index=0&id=296d466c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "296d466c",
  null
  
)

export default component.exports